/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 17,
    height: 3,
    viewBox: '0 0 17 3',
    data: '<path pid="0" d="M0 .65h17v1.7H0V.65z" _fill="#0078D2"/>'
  }
})
